import React from 'react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      title: "Coating Inspection (NACE/SSPC)",
      description: "Our quality control and quality assurance inspection services ensure that coating applications meet the highest industry standards and specifications throughout every phase of your project.",
      image: "https://public.readdy.ai/ai/img_res/ea964d28d2afa52e9b5f35584e97441d.jpg"
    },
    {
      title: "Specification Development & Review",
      image: "https://readdy.ai/api/search-image?query=Bridge%20engineering%20team%20reviewing%20detailed%20coating%20specifications%20and%20technical%20blueprints%20for%20steel%20bridge%20structures%20on%20large%20desk%20with%20laptop%20computers%20showing%20bridge%20cross-sections%20and%20coating%20system%20charts%2C%20professional%20office%20with%20bridge%20architectural%20drawings%20and%20NACE%20standards%20documentation%2C%20collaborative%20workspace%20focused%20on%20bridge%20coating%20specifications&width=800&height=600&seq=bridge-spec-development-v2&orientation=landscape",
      description: "Coatings specifications are the backbone of any coatings project and must be tailored to each individual project. A coatings system that works for one project may not be the best solution for another project."
    },
    {
      title: "Project Consulting",
      image: "https://readdy.ai/api/search-image?query=Professional%20bridge%20coating%20consultants%20in%20safety%20vests%20conducting%20project%20meeting%20at%20bridge%20construction%20site%20with%20large%20steel%20bridge%20visible%20in%20background%2C%20modern%20site%20office%20with%20presentation%20screens%20displaying%20bridge%20coating%20project%20plans%20and%20maintenance%20schedules%2C%20collaborative%20consulting%20environment%20with%20bridge%20infrastructure%20expertise%20and%20technical%20documentation&width=800&height=600&seq=bridge-project-consulting-v2&orientation=landscape",
      description: "We use our years of expertise to offer our clients a full range of project development and management services."
    },
    {
      title: "Infrastructure Surveys & Assessments",
      image: "https://readdy.ai/api/search-image?query=Bridge%20infrastructure%20assessment%20team%20surveying%20large%20steel%20truss%20bridge%20structure%20with%20coating%20evaluation%20equipment%20and%20tablets%2C%20engineers%20with%20safety%20gear%20and%20measurement%20devices%20examining%20bridge%20steel%20girders%20and%20connection%20points%20for%20coating%20condition%20assessment%2C%20outdoor%20bridge%20setting%20with%20comprehensive%20survey%20documentation%20tools%20and%20inspection%20scaffolding&width=800&height=600&seq=bridge-infrastructure-survey-v2&orientation=landscape",
      description: "With our staffs' years of experience in all aspects of the coatings industry, we can assist you with whatever your projects' needs are."
    },
    {
      title: "Specialty Testing/Services",
      image: "https://readdy.ai/api/search-image?query=Bridge%20coating%20specialist%20performing%20specialized%20adhesion%20testing%20and%20coating%20thickness%20measurements%20on%20steel%20bridge%20components%20with%20advanced%20testing%20equipment%20and%20analysis%20instruments%2C%20bridge%20maintenance%20facility%20with%20quality%20control%20samples%20of%20bridge%20coating%20systems%20and%20measurement%20devices%2C%20professional%20testing%20environment%20with%20bridge%20steel%20specimens%20and%20coating%20test%20panels&width=800&height=600&seq=bridge-specialty-testing-v2&orientation=landscape",
      description: "We engage in many forms of testing & inspection throughout many industries."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Comprehensive Coating Inspection Services
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-4"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            We offer a full range of services from coatings inspection to specification development and review, ensuring the highest quality standards for your projects.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 group">
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
